<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.center_execute"></strong>
          </div>

          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.caption"
              label-for="caption"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.caption"
                :rules="$v.caption.$params"
              />
              <b-form-input
                id="caption"
                type="text"
                :autocomplete="$lang.caption"
                v-model="$v.caption.$model"
                :state="$v.caption.$dirty ? !$v.caption.$error : null"
              >
              </b-form-input>
              <b-form-invalid-feedback id="caption-feedback"
                >{{ $lang.error_required | replace($lang.caption) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.company"
              label-for="company_selected"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.company"
                :rules="$v.company_selected.$params"
              />
              <selectFind
                :options="company_options"
                v-model="$v.company_selected.$model"
                label="name"
                id="code"
                :isValid="
                  $v.company_selected.$dirty
                    ? !$v.company_selected.$error
                    : null
                "
                :loading="company_loading"
                @input="getTerms"
              />
              <b-form-invalid-feedback id="company-feedback"
                >{{ $lang.error_required | replace($lang.company) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.select_term"
              label-for="term_selected"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.select_term"
                :rules="$v.term_selected.$params"
              />

              <selectFind
                :options="term_options"
                v-model="$v.term_selected.$model"
                label="caption"
                id="code"
                :loading="term_loading"
                @input="getTemplate"
                :isValid="
                  $v.term_selected.$dirty ? !$v.term_selected.$error : null
                "
              />
              <b-form-invalid-feedback
                :style="{
                  display: $v.term_selected.$error ? 'block' : 'none',
                }"
                id="term_selected_feedback"
              >
                {{ $lang.error_required | replace($lang.select_term) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.template"
              label-for="template_selected"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.template"
                :rules="$v.template_selected.$params"
              />
              <selectFind
                :options="template_options"
                v-model="$v.template_selected.$model"
                label="caption"
                :isValid="
                  $v.template_selected.$dirty
                    ? !$v.template_selected.$error
                    : null
                "
                :loading="template_loading"
                @input="getAssessmentPlan"
              />

              <b-form-invalid-feedback
                id="template_selected-feedback"
                :style="{
                  display: $v.template_selected.$error ? 'block' : 'none',
                }"
              >
                {{
                  $lang.error_required | replace($lang.template)
                }}</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="$lang.assessment_plan"
              label-for="assessment_plan_id"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.assessment_plan"
                :rules="$v.assessment_plan_selected.$params"
              />
              <selectFind
                :options="assessment_plan_options"
                v-model="$v.assessment_plan_selected.$model"
                label="name"
                :isValid="
                  $v.assessment_plan_selected.$dirty
                    ? !$v.assessment_plan_selected.$error
                    : null
                "
                :loading="assessment_plan_loading"
              />

              <b-form-invalid-feedback id="assessment_plan-feedback">
                {{
                  $lang.error_required | replace($lang.assessment_plan)
                }}</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="$lang.start_date"
              label-for="start_date"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.start_date"
                :rules="$v.start_date.$params"
              />
              <date-picker
                v-model="$v.start_date.$model"
                :state="$v.start_date.$dirty ? !$v.start_date.$error : null"
                format="YYYY/MM/DD"
                display-format="jYYYY/jMM/jDD"
                inputReq="true"
                :class="
                  $v.start_date.$dirty
                    ? $v.start_date.$error
                      ? 'invalid-date'
                      : 'valid-date'
                    : null
                "
              ></date-picker>

              <b-form-invalid-feedback id="start_date-feedback"
                >{{ $lang.error_required | replace($lang.start_date) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-checkbox
              id="begin_center_time"
              v-model="begin_center_time"
              name="begin_center_time"
              value="1"
              unchecked-value="0"
            >
              {{ $lang.begin_center_time }}
              <i
                class="fa fa-info-circle fa-lg text-info"
                v-b-tooltip.hover
                :title="$lang.begin_center_time_tooltip"
              ></i>
            </b-form-checkbox>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.close }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "add-center_execute",
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    company_selected: { required },
    term_selected: { required },
    assessment_plan_selected: { required },
    start_date: { required },
    template_selected: { required },
    caption: { required },
  },
  props: {
    mode: {
      type: String,
      default: "add",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    center_execute_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      caption: null,
      isLoading: false,
      company_selected: null,
      term_options: [],
      term_selected: null,
      term_loading: false,
      start_date: null,
      begin_center_time: 0,
      company_options: [],
      assessment_plan_options: [],
      assessment_plan_selected: null,
      assessment_plan_loading: false,
      company_loading: false,
      template_loading: false,
      template_selected: null,
      template_options: [],
    };
  },
  created() {
    this.getCompany();
  },
  methods: {
    pathOr,
    generateApiUrl,
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      (this.company_selected = null),
        (this.assessment_plan_selected = null),
        (this.start_date = null);
    },
    changes() {},
    async getCompany() {
      try {
        this.company_loading = true;
        const url = generateApiUrl(["kanoon", "company_combo"]);
        const response = await this.$httpService.get(url);
        this.company_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.company_loading = false;
      }
    },
    async getTerms(company) {
      try {
        // reset sub combos
        this.term_selected = null;
        this.template_selected = null;
        this.assessment_plan_selected = null;
        this.term_options = [];
        this.template_options = [];
        this.assessment_plan_options = [];

        this.term_loading = true;
        const company_code = pathOr(null, ["code"], company);
        const url = generateApiUrl(["kanoon", "term_combo"], [], {
          company_code,
        });
        const response = await this.$httpService.get(url);
        this.term_options = pathOr([], ["data", "data"], response).map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              code: pathOr(null, ["code"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_loading = false;
      }
    },
    async getTemplate() {
      try {
        // reset sub combos
        this.template_selected = null;
        this.assessment_plan_selected = null;
        this.template_options = [];
        this.assessment_plan_options = [];

        this.template_loading = true;
        const companyCode = pathOr(null, ["code"], this.company_selected);
        const url = generateApiUrl(["kanoon", "template_combo"], [], {
          "company_code[]": companyCode,
          completed: true,
        });
        const response = await this.$httpService.get(url);
        this.template_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.template_loading = false;
      }
    },
    async getAssessmentPlan(template) {
      try {
        this.assessment_plan_selected = null;
        this.assessment_plan_options = [];

        this.assessment_plan_loading = true;
        const template_id = pathOr(null, ["id"], template);
        const url = generateApiUrl(["kanoon", "assessment_plan_combo"], [], {
          template_id,
          has_plan: true,
        });
        const response = await this.$httpService.get(url);
        this.assessment_plan_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessment_plan_loading = false;
      }
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "center_execute"]);
        const payload = {
          /* guidance: template just for show not need in payload */
          company_code: pathOr(null, ["code"], this.company_selected),
          term_code: pathOr(null, ["code"], this.term_selected),
          assessment_plan_id: pathOr(
            null,
            ["id"],
            this.assessment_plan_selected
          ),
          start_date: this.start_date,
          begin_center_time: +this.begin_center_time,
          caption: this.caption,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

